import React, { FC } from 'react';
import Grid from '@mui/material/Grid';

import './SCUIPage.scss';
import { SCUIHeader } from '../../organisms';
interface ISCUIPage {
    children?: React.ReactNode;
    history?: any;
}

export const SCUIPage: FC<ISCUIPage> = ({ children, history }) => {
    return (
        <Grid container className="sc-content-area">
            <Grid
                size={{
                    xs: 12,
                }}
            >
                <SCUIHeader history={history} />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                }}
            >
                <section className="content-wrapper">{children}</section>
            </Grid>
        </Grid>
    );
};
